import { Button, Heading } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { companyAchMethodTypePath, companyPaymentMethodsPath } from "@oysterhr/router"
import { OverviewStep } from "../../../../../components/OverviewStep"
import { PlaidLinkFlow } from "../../../../plaid/PlaidLinkFlow"

type AchContractorOverviewProps = {
  companyId: string
}

export const AchContractorOverview = ({ companyId }: AchContractorOverviewProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchMethodOverview", {
    keyPrefix: "contractor",
  })
  const navigate = useNavigate()

  const stepsOptionA = useMemo(
    () => [
      {
        title: t("option-a.steps.logInOpenBank.title"),
        content: t("option-a.steps.logInOpenBank.content"),
      },
      {
        title: t("option-a.steps.authorizeDirectDebit.title"),
        content: t("option-a.steps.authorizeDirectDebit.content"),
      },
      {
        title: t("option-a.steps.shareConfirmationLink.title"),
        content: t("option-a.steps.shareConfirmationLink.content"),
      },
    ],
    [t],
  )

  const stepsOptionB = useMemo(
    () => [
      {
        title: t("option-b.steps.addPaymentMethod.title"),
        content: t("option-b.steps.addPaymentMethod.content"),
      },
      {
        title: t("option-b.steps.checkBankAccount.title"),
        content: t("option-b.steps.checkBankAccount.content"),
      },
      {
        title: t("option-b.steps.verifyPaymentMethod.title"),
        content: t("option-b.steps.verifyPaymentMethod.content"),
      },
      {
        title: t("option-b.steps.authorizeDirectDebit.title"),
        content: t("option-b.steps.authorizeDirectDebit.content"),
      },
      {
        title: t("option-b.steps.shareConfirmationLink.title"),
        content: t("option-b.steps.shareConfirmationLink.content"),
      },
    ],
    [t],
  )

  return (
    <div className="mt-6">
      <div className="mb-6">
        <Heading size="lg">{t("option-a.header")}</Heading>
        <div className="my-4 rounded-lg border-2 border-gray-200 p-4">
          <ul className="grid grid-cols-1 justify-items-start gap-4">
            {stepsOptionA.map((step, index) => (
              <OverviewStep
                key={step.title}
                title={step.title}
                content={step.content}
                step={index + 1}
              />
            ))}
          </ul>
        </div>
        <PlaidLinkFlow
          onSubmit={() => navigate(companyPaymentMethodsPath(companyId))}
          companyId={companyId}
        />
      </div>
      <Heading size="lg">{t("option-b.header")}</Heading>
      <div>
        <div className="my-4 rounded-lg border-2 border-gray-200 p-4">
          <ul className="grid grid-cols-1 justify-items-start gap-4">
            {stepsOptionB.map((step, index) => (
              <OverviewStep
                key={step.title}
                title={step.title}
                content={step.content}
                step={index + 1}
              />
            ))}
          </ul>
        </div>
        <Button
          as={Link}
          to={companyAchMethodTypePath(companyId, "contractor")}
          variation="secondary"
        >
          {t("option-b.connectManuallyButton")}
        </Button>
      </div>
    </div>
  )
}
